import React, { Component } from 'react';
import SocialProfile from '../../components/Social/SocialProfile';
import Levels from '../../components/Social/Levels';
import Social from '../../utils/social/Social';

class SocialProfileManager extends Component {
  constructor(props) {
      super(props);
  }

  render() {
      let gamesArray;
      let percentage;
      if(this.props.gameId && this.props.userSocial.gamesArray)
          gamesArray = Social.filterGamesArray(this.props.gameId, this.props.userSocial.gamesArray);

      if(gamesArray)
          percentage = Social.porcentageProgressBar(gamesArray);

      return(<div className="social-header">
              <div className="personal-info">
                  <SocialProfile
                      large={true}
                      userSocial={this.props.userSocial}
                      user={this.props.user}
                      translations={this.props.translations}
                      isCurrentUser={this.props.isCurrentUser}
                      ownFollowings={ this.props.ownFollowings }
                      gamificationIdUserlogged={ this.props.gamificationIdUserlogged }
                      incOwnFollowings={ this.props.incOwnFollowings }
                      decOwnFollowings={ this.props.decOwnFollowings }
                      nameFromisloggedin={this.props.nameFromisloggedin}
                  />
              </div>
              <div className="levels">
                  { gamesArray && <Levels
                      userSocial={this.props.userSocial}
                      translations={this.props.translations}
                      gamesArray={gamesArray}
                      percentage={percentage}
                  />}
              </div>
          </div>)
  }

}

export default SocialProfileManager;



// WEBPACK FOOTER //
// ./src/containers/Social/SocialProfileManager.jsx